<template>
    <div>
        <div class="accountant-component">
            <div class="container-fluid">
                <div class="row">

                    <accountant-expenditure />

                </div>
            </div>
        </div>

        <accountant-transactions />
    </div>

</template>

<script>

import AccountantExpenditure from "./components/AccountantExpenditure";
import AccountantTransactions from "./components/AccountantTransactions";

export default {
    name: "AccountantComponent",
    components: { AccountantExpenditure, AccountantTransactions },


}
</script>

<style lang="scss" scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}
.file-wrapp{
    display: block;
    background: #007bff;
    color: #fff;
    position: relative;
    font-size: 14px;
    line-height: 18px;
    border-radius: 4px;
    padding: 5px 25px;
    margin-top: 10px;
}

.file-delete{
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    cursor: pointer;
    background: #3D9BFF;
}

.modal-text{
    display: block;
    margin-bottom: 10px;
    font-size: 14px;
    color: #555;

    .text-danger{
        padding: 0 10px;
        font-weight: 700;
    }

    .upload{
        display: block;
        background: #007bff;
        color: #fff;
        text-align: center;
        position: relative;
        line-height: 25px;
        border-radius: 4px;
        padding: 5px 25px;
        input{
            position: absolute;

            left: 0;
            top: 0;
            opacity: 0;
            z-index: -1;
            visibility: hidden;
        }
    }
}

.text-field{
    background: #f4f5f8;
    border: none;
    line-height: 25px;
    border-radius: 4px;
    padding: 5px 25px;
    margin-bottom: 0;
    height: unset;
    font-size: 15px;
    color: #333;
    width: 100%;
    resize: none;
}

.card .text-field{
    padding: 15px 25px;
}

.upload_cross{
    line-height: 28px;
    vertical-align: -11px;
    width: 28px;
    border-radius: 3px;
    background: rgba(6, 116, 236, 0.1);
    font-size: 14px;
    display: inline-block;
    text-align: center;
    color: #0674ec;
}
</style>

<style lang="scss">



.preview-doc {
    width: 50px;
    margin-right: 5px;
}

.paginator ul {
    list-style: none;
    padding: inherit;
    margin: 0 auto;
    display: inline-block;


    li {
        padding: 2px 10px;
        background-color: #527bff;
        float: left;
        margin-right: 10px;
        border-radius: 50%;
        color: #fff;

    }
}
.cursor-pointer {
    cursor: pointer;
}

.nowrap,
.actions {
    white-space: nowrap;
}

.attached_images a {
    display: inline-block;
    margin-right: 3px;
    margin-bottom: 3px;

    &:last-child {
        margin-right: 0;
        margin-bottom: 0;
    }

    img {
        max-width: 50px;
        max-height: 50px;
    }
}

</style>
